import Table from "../components/application-form/Table";
import { SpaceBetween } from "@cloudscape-design/components-themed";
import { useAuthenticationHook } from "../app/useAuthenticationHook";
import { PERMISSIONS } from "../configs/constants";

/* 
申請様式一覧画面
 */
const ApplicationFormList = () => {
  //権限制御
  useAuthenticationHook(PERMISSIONS.MASTER_EDIT);
  return (
    <SpaceBetween size="l">
      <Table />
    </SpaceBetween>
  );
};

export default ApplicationFormList;
